export default "__VITE_ASSET__DrnlhEEw__"